import { Map as ImmutableMap } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';
import { isSucceeded, getData } from '../../constants/asyncStatuses';
import { getResolvedAttachments } from './getResolvedAttachments';
export const getSuccessfulFileAttachments = createSelector([getResolvedAttachments], resolvedAttachmentsMap => {
  if (!resolvedAttachmentsMap || !resolvedAttachmentsMap.size) {
    return ImmutableMap();
  }
  return resolvedAttachmentsMap.reduce((successfulAttachments, entry, attachmentId) => {
    var _getData;
    if (!entry || !attachmentId || !isSucceeded(entry)) {
      return successfulAttachments;
    }
    return successfulAttachments.set(String(attachmentId), (_getData = getData(entry)) !== null && _getData !== void 0 ? _getData : null);
  }, ImmutableMap());
});